/* global axios */
import ApiClient from './ApiClient';

class CommercialGoalsAPI extends ApiClient {
  constructor() {
    super('commercial_goals', { accountScoped: true });
  }

  list(params) {
    return axios.get(this.url, { params });
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(attrs) {
    return axios.post(this.url, { commercial_goal: attrs });
  }

  update(id, attrs) {
    return axios.patch(`${this.url}/${id}`, { commercial_goal: attrs });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getProgress() {
    return axios.get(`${this.url}/progress`);
  }

  getMyProgress() {
    return axios.get(`${this.url}/my_progress`);
  }
}

export default new CommercialGoalsAPI();
